import { Component, OnInit, Input } from '@angular/core';
import {
  Barcode,
  MemberDetails,
  MemberQuery,
  PopulationQuery,
  BarcodeService,
  BarcodeQuery,
  BalanceQuery,
  config,
} from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() memberId: string;
  @Input() pageTitle: string = '';
  @Input() isWalletPage: boolean = false;
  @Input() isHomePage: boolean = false;
  @Input() showBalance: boolean = false;
  @Input() showQr: boolean = false;
  @Input() backButtonLink?: string;
  barcode$: Observable<Barcode>;
  member$: Observable<MemberDetails | undefined>;
  pointsBalance$: Observable<number | undefined>;

  populations = Populations;
  isCorporate: boolean;
  isJuniorBlueBirds: boolean;
  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private memberDetailsQuery: MemberQuery,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit() {
    this.member$ = this.memberDetailsQuery.selectMemberDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
    this.isJuniorBlueBirds = this.populationQuery.userInPopulation([this.populations.JuniorBluebirds]);
    firstValueFrom(this.barcodeService.fetchBarcode());
    this.barcode$ = this.barcodeQuery.select();
  }
}
